import { useLayoutEffect } from 'react';
import { CommonActions } from '@react-navigation/native';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { getAppNavigationContainerRef } from '../../navigation/AppNavigation.ref';
import type { NavigationActionPayloadWithMaintenanceFlag } from './types';

/**
 * Toggle maintenance mode screen based on the change of the corresponding feature flag
 */
export const useMaintenanceMode = () => {
  // Use the external app navigation reference to get access to
  // the navigation object outside the corresponding container
  const { current: appNavigation } = getAppNavigationContainerRef();

  const isMaintenanceModeEnabled = useFeatureFlag(
    'OPS-enable-maintenance-mode',
    { listenForChanges: true },
  );

  // ─────────────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    if (!appNavigation || !isMaintenanceModeEnabled) return;

    // open `MaintenanceModeScreen` if the maintenance mode is on
    appNavigation.navigate('Maintenance', { screen: 'MaintenanceMode' });

    // close `MaintenanceModeScreen` if the maintenance mode has been turned off
    return () => {
      const payload: NavigationActionPayloadWithMaintenanceFlag = {
        shouldDisableMaintenanceMode: true,
      };

      appNavigation.dispatch({ ...CommonActions.goBack(), payload });
    };
  }, [appNavigation, isMaintenanceModeEnabled]);
};
